import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class ForbiddenException extends LicenseException
{

}
